"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NATIVE_HTML_BUTTON_TYPES = exports.Button = exports.BUTTON_TYPES = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Icon = require("../Icon/Icon");
var _isReactFragment = require("../utils/isReactFragment");
var _useUniqueId = require("../utils/useUniqueId");
var _constants = require("../utils/constants");
var _ToolbarOverflowLayout = require("../Toolbar/_ToolbarOverflowLayout");
var _Button = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Button.css") : void 0);
var _excluded = ["active", "allowFocusOnDisable", "children", "className", "compact", "disabled", "disabledMessage", "enabledMessage", "hideCreateIcon", "innerTextClasses", "innerTextProps", "muted", "nativeHTMLButtonType", "size", "type", "onClick", "inToolbarOverflow", "toolbarOverflowEnd", "toolbarLayoutProps"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-button';
var BUTTON_TYPES = exports.BUTTON_TYPES = ['default', 'primary', 'secondary', 'success', 'info', 'warning', 'danger', 'error', 'link', 'create'];
var NATIVE_HTML_BUTTON_TYPES = exports.NATIVE_HTML_BUTTON_TYPES = ['button', 'reset', 'submit'];

/**
 * **Button** components are used to communicate and trigger an action, when interacted with.
 * If the user is being redirected to another page
 * in or outside of the application use a **Link** instead of a **Button**.
 */

var Button = exports.Button = /*#__PURE__*/_react.default.forwardRef(function (_props, ref) {
  var _context, _context2;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Button, _props)) : _props;
  var active = props.active,
    _props$allowFocusOnDi = props.allowFocusOnDisable,
    allowFocusOnDisable = _props$allowFocusOnDi === void 0 ? false : _props$allowFocusOnDi,
    children = props.children,
    className = props.className,
    compact = props.compact,
    disabled = props.disabled,
    disabledMessage = props.disabledMessage,
    enabledMessage = props.enabledMessage,
    hideCreateIcon = props.hideCreateIcon,
    innerTextClasses = props.innerTextClasses,
    innerTextProps = props.innerTextProps,
    _props$muted = props.muted,
    muted = _props$muted === void 0 ? false : _props$muted,
    _props$nativeHTMLButt = props.nativeHTMLButtonType,
    nativeHTMLButtonType = _props$nativeHTMLButt === void 0 ? 'button' : _props$nativeHTMLButt,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'default' : _props$type,
    onClick = props.onClick,
    inToolbarOverflow = props.inToolbarOverflow,
    toolbarOverflowEnd = props.toolbarOverflowEnd,
    toolbarLayoutProps = props.toolbarLayoutProps,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_Button.default);
  var classes = classnames(CSS_BLOCK, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, type), className, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, (0, _concat.default)(_context2 = "".concat(CSS_BLOCK, "--")).call(_context2, size), size !== 'md'), "".concat(CSS_BLOCK, "--muted"), muted && type !== 'create'), "".concat(CSS_BLOCK, "--active"), active), "".concat(CSS_BLOCK, "--compact"), compact && type === 'link'));
  var ariaDisabled = otherProps['aria-disabled'];
  var disabledInAnyWay = disabled || ariaDisabled;

  // if button is disabled and focusable, remove onClick handler
  var onClickHandler = allowFocusOnDisable && disabledInAnyWay ? function () {} : onClick;
  var ariaLiveId = (0, _useUniqueId.useUniqueId)();
  var passChildProps = function passChildProps(child, childProps) {
    var childClassName = childProps.className,
      forceSize = childProps.forceSize;
    if (child.displayName === 'Badge') {
      return {
        className: classnames("".concat(CSS_BLOCK, "__badge"), childClassName)
      };
    }
    if (child.displayName === 'Icon') {
      var iconSizeMap = {
        lg: 'sm',
        md: 'sm-minus'
      };

      // Future breaking change:
      // The classForSemanticIconInButton isn't necessary
      var iconName = childProps.iconName;
      var SEMANTIC_ICONS = ['messaging-success', 'messaging-info', 'messaging-warning', 'messaging-error', 'messaging-help'];
      var classForSemanticIconInButton = '';
      if (iconName && SEMANTIC_ICONS.indexOf(iconName) !== -1) {
        var _context3;
        classForSemanticIconInButton = (0, _concat.default)(_context3 = "".concat(CSS_BLOCK, "__icon--")).call(_context3, iconName);
      }
      return {
        className: classnames("".concat(CSS_BLOCK, "__icon"), classForSemanticIconInButton, childClassName),
        size: forceSize || iconSizeMap[size]
      };
    }
    return null;
  };
  var getDisabledProps = function getDisabledProps() {
    var disabledProps = {};
    if (allowFocusOnDisable) {
      disabledProps['aria-disabled'] = disabledInAnyWay;
      disabledProps['aria-describedby'] = ariaLiveId;
    } else {
      disabledProps.disabled = disabledInAnyWay;
    }
    return disabledProps;
  };
  var createIcon = type === 'create' && !hideCreateIcon && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    iconName: size === 'lg' ? 'plus' : 'plus-3'
  });
  var renderChildren = function renderChildren(childNodes) {
    var _context4;
    var textNodeSegment = [];
    var innerTextClassName = classnames(innerTextClasses, "".concat(CSS_BLOCK, "__text"));
    var startIconOrBadge = createIcon;
    var centerText = [];
    var endIconOrBadge;
    var alteredChildren = (0, _map.default)(_context4 = _react.default.Children).call(_context4, childNodes, function (child) {
      var _child$type, _child$type2, _child$type3, _child$type4;
      if (child === null) return null;
      if ((0, _isReactFragment.isReactFragment)(child)) {
        return renderChildren(child.props.children);
      }
      var isIconOrBadge = ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.displayName) === 'Icon' || ((_child$type2 = child.type) === null || _child$type2 === void 0 ? void 0 : _child$type2.displayName) === 'Badge';
      var isTextNodeSegment = ! /*#__PURE__*/_react.default.isValidElement(child) || ((_child$type3 = child.type) === null || _child$type3 === void 0 ? void 0 : _child$type3.displayName) !== 'Icon' && ((_child$type4 = child.type) === null || _child$type4 === void 0 ? void 0 : _child$type4.displayName) !== 'Badge';
      if (isIconOrBadge) {
        if (!startIconOrBadge && !(centerText !== null && centerText !== void 0 && centerText.length)) {
          startIconOrBadge = child;
        } else {
          endIconOrBadge = child;
        }
      }
      if (isTextNodeSegment) {
        centerText.push(child);
        textNodeSegment.push(child);
      } else {
        if (textNodeSegment.length) {
          var textChild = textNodeSegment;
          textNodeSegment = [];
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, innerTextProps, {
            className: innerTextClassName
          }), textChild), child);
        }
        return child;
      }
      return null;
    });
    if (inToolbarOverflow) {
      return /*#__PURE__*/_react.default.createElement(_ToolbarOverflowLayout.ToolbarOverflowLayout, (0, _extends2.default)({
        startIconOrBadge: startIconOrBadge,
        innerTextClassName: innerTextClassName,
        centerText: centerText,
        toolbarOverflowEnd: toolbarOverflowEnd,
        endIconOrBadge: endIconOrBadge,
        size: size
      }, toolbarLayoutProps));
    }
    if (textNodeSegment.length) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, alteredChildren, /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, innerTextProps, {
        className: innerTextClassName
      }), textNodeSegment));
    }
    return alteredChildren;
  };
  var buttonComp = /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({}, otherProps, getDisabledProps(), {
    className: classes,
    onClick: onClickHandler,
    ref: ref
    // eslint-disable-next-line react/button-has-type
    ,
    type: nativeHTMLButtonType
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, !inToolbarOverflow && createIcon, renderChildren(children)));
  var liveMessageForScreenReaders = disabledInAnyWay ? disabledMessage : enabledMessage;
  var renderButtonStateMessage = function renderButtonStateMessage() {
    var content = '';
    if (allowFocusOnDisable && disabledInAnyWay !== null) {
      content = /*#__PURE__*/_react.default.createElement("p", {
        "aria-live": "assertive",
        className: classnames("".concat(CSS_BLOCK, "--screen-reader-only")),
        id: ariaLiveId
      }, liveMessageForScreenReaders);
    }
    return content;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, buttonComp, renderButtonStateMessage());
});
Button.displayName = 'Button';

// eslint-disable-next-line consistent-return
var validateStateTransitionMessage = function validateStateTransitionMessage(props, propName) {
  if (props.allowFocusOnDisable && (props.disabled !== null || props['aria-disabled']) && !props[propName]) {
    return new Error("\n        Missing or invalid value for ".concat(propName, ".\n        If this button can receive focus when disabled (i.e. allowFocusOnDisable prop is true),\n        you need to provide localized string values for the enabled and disabled states.\n        These strings are used to announce the state change by assistive technologies.\n        Hence, these should be specified for a better, accessible experience.\n        For e.g. \n        <Button\n            disabled={someLogic()}\n            allowFocusOnDisable\n            disabledMessage=\"Please complete required form fields to enable form submission.\"\n            enabledMessage=\"Please press the submit button to proceed.\">\n            Submit\n        </Button>\n        "));
  }
};
Button.propTypes = {
  /** Set to `true` to show active/pressed state. */
  active: _propTypes.default.bool,
  /** Set to `true` to allow the **Button** to receive focus when it is disabled. */
  allowFocusOnDisable: _propTypes.default.bool,
  /** Collection of React components to be placed in the **Button**. */
  children: _propTypes.default.node,
  /** Custom classes to be added to the `<button>` tag. */
  className: _propTypes.default.string,
  /** Used to remove padding and height from link buttons. */
  compact: _propTypes.default.bool,
  /** Set to `true` to disable the **Button**. */
  disabled: _propTypes.default.bool,
  /** A visually hidden hint message to be conveyed to users of assistive
   * technologies like screen readers, when **Button** changes state to disabled.
   * This message should explain why this action is disabled or how to enable it.
   * For example,
   * "This action is restricted to some users" OR "Please fill required fields before submitting"
   */
  disabledMessage: validateStateTransitionMessage,
  /** A visually hidden hint message to be conveyed to users of assistive
   * technologies like screen readers, when **Button** changes state to enabled.
   * This message should call out the fact that this action is now enabled.
   * For example, "Press submit to proceed" */
  enabledMessage: validateStateTransitionMessage,
  /** Custom classes to be added to the inner `<span>` of the `<button>`
   * that holds the text content. */
  innerTextClasses: _propTypes.default.string,
  /** Additional props to be spread to the inner `<span>` of the `<button>`
   * that holds the text content. */
  innerTextProps: _propTypes.default.object,
  /** Set to `true` to render alternate muted style (only available in Gateway theme) */
  muted: _propTypes.default.bool,
  /** Sets the HTML `<button>` `type` attribute. Options are 'button', 'reset', 'submit'. */
  nativeHTMLButtonType: _propTypes.default.oneOf(NATIVE_HTML_BUTTON_TYPES),
  /** **Button** size. Options are 'lg', 'md'. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES),
  /** **Button** type. Options are 'primary', 'default', 'create', 'link'. */
  type: _propTypes.default.oneOf(BUTTON_TYPES),
  /** @ignore set by SplitButton's icon. */
  hideCreateIcon: _propTypes.default.bool,
  /** @ignore set by ToolbarOverflow. */
  inToolbarOverflow: _propTypes.default.bool,
  /** @ignore set by ToolbarOverflow. */
  toolbarLayoutProps: _propTypes.default.any,
  /** @ignore set by ToolbarOverflow. */
  toolbarOverflowEnd: _propTypes.default.node,
  /** Callback function for onClick events.
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   */
  onClick: _propTypes.default.func
};
var _default = exports.default = Button;